module.exports = __webpack_public_path__ + "static/media/mapMarker.53ff098f.svg";